import { CX, CY, RX, RY, VIEWBOX, type Layout } from '../../lib/capture/headmap'
import { WORDS, type Tier } from '../../lib/capture/quality'

/**
 * The head seen from above, nose at the top. Every dot carries a `<title>` and
 * a visible word so colour is never alone. `focus` is the channel to halo.
 * Geometry from `lib/capture/headmap.ts`, asserted against Canvas 05.
 */
export function HeadMap({
  layout,
  tiers,
  focus = null,
}: {
  layout: Layout
  tiers: Readonly<Record<string, Tier>>
  focus?: string | null
}) {
  return (
    <svg className="headmap" viewBox={VIEWBOX} role="img" aria-label="Headband contacts seen from above, nose at the top">
      <text className="clbl" x="230" y="30" textAnchor="middle">
        FRONT
      </text>
      <path className="head" d="M214 66 Q230 46 246 66" />
      <ellipse className="head" cx="230" cy="175" rx="92" ry="112" />
      <ellipse className="head" cx="134" cy="178" rx="7" ry="14" />
      <ellipse className="head" cx="326" cy="178" rx="7" ry="14" />
      <ellipse className="band" cx={CX} cy={CY} rx={RX} ry={RY} />
      {layout.placed.map((p) => {
        const tier = tiers[p.channel] ?? 'none'
        const word = WORDS[tier]
        return (
          <g key={p.channel}>
            <line className="clead" x1={p.x} y1={p.y} x2={p.lx2} y2={p.ly2} />
            <text className="clbl" x={p.lx} y={p.ly} textAnchor={p.anchor}>
              {p.loc}
            </text>
            <text className={`cword cword--${tier}`} x={p.lx} y={p.ly + 13} textAnchor={p.anchor}>
              {word}
            </text>
            <g className="contact-dot" data-channel={p.channel} data-tier={tier}>
              <title>{`${p.loc} (${p.channel}) · ${word}`}</title>
              {focus === p.channel && <circle className="chalo" cx={p.x} cy={p.y} r="12" />}
              <circle className={`cdot cdot--${tier}`} cx={p.x} cy={p.y} r="10" />
            </g>
          </g>
        )
      })}
    </svg>
  )
}
